import {
	IBaseNotificationPayload,
	INotificationPayload,
	INotificationsSet,
	Partial,
} from '@modules/notification-management/interfaces/notifications.interface';
import { EditNotificationSetModalService } from '@modules/notification-management/modals/edit-notification-set-modal/edit-notification-set-modal.service';
import { BaseModalComponent } from '@app/components/modals/base/base-modal.component';
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Component({
	selector: 'app-edit-notification-set-modal',
	templateUrl: './edit-notification-set-modal.component.html',
	styleUrls: ['./edit-notification-set-modal.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [EditNotificationSetModalService],
})
export class EditNotificationSetModalComponent extends BaseModalComponent implements OnDestroy {
	public readonly channels$: Observable<string[]> = this.service.getSlackChannels().pipe(map((x) => x.channels));
	public readonly editNotification$: Observable<INotificationsSet> = this.service.getDetails();
	public readonly hasSlack$: Observable<boolean> = this.service.hasSlack();
	public readonly hasTeams$: Observable<boolean> = this.service.hasTeams();

	protected _title = 'Edit Notification Set';

	private _orgId: number;

	constructor(public service: EditNotificationSetModalService) {
		super();
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
		this.service.reset();
	}

	public setup(config: IBaseNotificationPayload): void {
		this._orgId = config.org_id;
		this.service.loadDetails(config).pipe(takeUntil(this.unsubscribe)).subscribe();
	}

	public close(): void {
		this._hideFunc();
	}

	public save($event: Partial<INotificationPayload>): void {
		this.service
			.edit({ ...$event, org_id: this._orgId })
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((response) => {
				if (response) {
					this._hideFunc();
				}
			});
	}
}
